module.exports = __webpack_public_path__ + "img/logo.4e8a50dd.png";